import React from 'react';

const Editorial = () => {
  return (
    <>
      <style>{`
.editorial {
  max-width: 1200px;
  margin: 0 auto;
  line-height: 1.65;
  color: #00bc8c;
  padding: 0 2em;
}

.lang-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(470px, 1fr));
  gap: 48px;
}

.lang-column h2 {
  margin: 0 0 2rem;
  padding-bottom: .45rem;
  font-size: 1.7rem;
  font-weight: 600;
}

.example-label {
  margin: 2rem 0 .8rem;
  padding-bottom: .25rem;
  border-bottom: 1px solid #ccc;
  font-size: .9rem;
  font-weight: 600;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

.current-box {
  margin-bottom: 1.8rem;
  padding: 1rem 1.2rem;
  border: 1px solid #d8d8d8;
  border-left: 4px solid #999;
  background: #fafafa;
  color: #666;
  border-radius: 0;
  font-size: .98rem;
}

.recommended-box {
  border: 2px solid #333;
  background: #fff;
  padding: 1.4rem;
  border-radius: 0;
  box-shadow: none;
}

.recommended-title {
  margin-bottom: 1rem;
  padding-bottom: .45rem;
  border-bottom: 1px solid #ccc;
  color: #111;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
}

.recommended-text {
  padding: 1rem 1.2rem;
  border: 1px solid #bbb;
  background: #fcfcfc;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.05rem;
  line-height: 1.75;
  color: #222;
  border-radius: 0;
}

.commentary {
  margin-top: 1.4rem;
  padding-top: 1rem;
  border-top: 1px solid #d7d7d7;
}

.commentary-title {
  margin-bottom: .5rem;
  font-weight: 700;
  font-size: .95rem;
  color: #333;
}

.commentary p {
  margin: 0;
  color: #444;
  font-size: .95rem;
  text-align: justify;
}

.notes {
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid #bbb;
  font-size: .88rem;
  color: #555;
}

.notes-title {
  margin-bottom: .7rem;
  font-weight: 700;
}

.notes ol {
  margin: 0;
  padding-left: 1.3rem;
}

.notes li {
  margin-bottom: .5rem;
}

sup {
  font-size: .72em;
  vertical-align: super;
}

@media (max-width: 900px) {
  .lang-grid {
      grid-template-columns: 1fr;
  }
}
      `}</style>

      <div className="editorial">

        <div className="lang-grid">

          {/* ENGLISH */}

          <div className="lang-column">

            <h2>English</h2>

            <div className="notes">In 2026, a comprehensive scholarly revision of the database descriptions was initiated. The first category of seals to undergo editorial standardization comprised seals bearing multi-line Greek inscriptions. The editorial guidelines adopted for their description are presented below.</div>

            <div className="example-label">
              Obverse
            </div>

            <div className="current-box">
              (Retrograde) (Greek) inscription in five lines:
              "Lord, help your servant Andrew, named Vsevolod". (Description of ornamental elements and
              abbreviation marks.) Border of dots (or linear border).
            </div>

            <div className="recommended-box">

              <div className="recommended-title">
                ✓ Recommended format
              </div>

              <div className="recommended-text">
                Greek five-line inscription (retrograde):
                "Lord, help your servant Andrew, named Vsevolod". (Border of dots.)
              </div>

              <div className="commentary">

                <div className="commentary-title">
                  Commentary
                </div>

                <p>
                  The language of the inscription should always be
                  specified. Particular attention should be paid to
                  the number of lines and to whether the inscription
                  is engraved in retrograde. The inscription itself,
                  together with all sigla and abbreviation marks,
                  should be reproduced using the Athena Ruby font.
                  The border may also be described where
                  appropriate.
                </p>

              </div>

            </div>


            <div style={{ marginTop: "2rem" }}>

            <div className="example-label">
              Reverse
            </div>

            <div className="current-box">
              Half-length (retrograde) representation of St Andrew the First-Called
              (with long hair falling to the shoulders), holding a cross on a long shaft
              beside the left [right] shoulder (in the left [right] hand). The right
              [left] hand is raised in a gesture of blessing. Columnar inscription at
              the sides. Border of dots.
            </div>

            <div className="recommended-box">

              <div className="recommended-title">
                ✓ Recommended format
              </div>

              <div className="recommended-text">
                Half-length representation of St Andrew the First-Called, with long hair
                falling to the shoulders. A cross on a long shaft is shown beside the
                right shoulder. The left hand is raised in a gesture of blessing.
                Vertical inscription. (Border of dots.)
              </div>

              <div className="commentary">

                <div className="commentary-title">
                  Commentary
                </div>

                <p>
                  The description should specify the format of the representation
                  (bust / half-length or full-length / standing) together with the
                  name of the saint. Where the iconography can be identified with
                  confidence, distinguishing epithets and characteristic iconographic
                  features should also be noted. The presence of a vertical inscription
                  should always be recorded. The same conventions apply to the
                  description of inscriptions and borders as those adopted for the
                  obverse.
                </p>

              </div>

              <div className="notes">
                <div className="notes-title">Notes</div>
                <ol>
                  <li>
                    Throughout both the database and the present publication, the convention
                    used by V. L. Yanin is followed, according to which the side
                    bearing the Greek inscription is designated as the obverse.
                  </li>

                  <li>
                    The example given above is based on one of the seals of Prince Vsevolod
                    Yaroslavich (†1093).
                  </li>

                  <li>
                    Elements enclosed in parentheses are optional and should be included
                    only where applicable.
                  </li>
                </ol>
            </div>

            </div>

          </div>


          </div>


          {/* RUSSIAN */}

          <div className="lang-column">

            <h2>Русский</h2>

            <div className="notes">В 2026 году в базе данных был начат процесс научного редактирования описаний печатей. Первыми объектами, для которых были разработаны единые редакционные принципы, стали древнерусские буллы с греческими многострочными надписями. Ниже представлены правила их описания, рекомендуемые редакторам базы данных.</div>

            <div className="example-label">
              Лицевая сторона
            </div>

            <div className="current-box">
              (Зеркальная) (Греческая) (благопожелательная)
              надпись [легенда] в пять строк
              «Господи, помоги рабу своему Андрею,
              названному Всеволод». (Описание орнаментов
              и титл.) Вокруг точечный ободок.
            </div>

            <div className="recommended-box">

              <div className="recommended-title">
                ✓ Рекомендуемый формат
              </div>

              <div className="recommended-text">
                (Зеркальная) Греческая пятистрочная
                надпись «Господи, помоги рабу своему
                Андрею, названному Всеволод».
                (Точечный ободок.)
              </div>

              <div className="commentary">

                <div className="commentary-title">
                  Пояснение
                </div>

                <p>
                  Необходимо указывать язык, на котором
                  выполнена легенда. Обращать внимание
                  на количество строк и зеркальность
                  надписи. Использовать современный
                  русский язык, не пытаясь воспроизводить
                  историческую орфографию. Саму легенду,
                  любые символы и титла передавать
                  средствами шрифта Athena Ruby.
                </p>

              </div>

            </div>

            <div style={{ marginTop: "2rem" }}>

<div className="example-label">
  Оборотная сторона
</div>

<div className="current-box">
  Погрудное [Поясное] (зеркальное) изображение св. Андрея
  Первозванного (с длинными волосами, ниспадающими до плеч)
  с крестом (на длинном древке) у левого [правого] плеча
  (в левой [правой] руке). Правая [левая] рука в благословляющем
  жесте. (По сторонам) колончатая надпись. Вокруг (точечный)
  ободок.
</div>

<div className="recommended-box">

  <div className="recommended-title">
    ✓ Рекомендуемый формат
  </div>

  <div className="recommended-text">
    Погрудное изображение св. Андрея Первозванного с длинными
    волосами, ниспадающими до плеч. У правого плеча крест
    на длинном древке. Левая рука в благословляющем жесте.
    Колончатая надпись. (Точечный ободок.)
  </div>

  <div className="commentary">

    <div className="commentary-title">
      Пояснение
    </div>

    <p>
      Указывать формат изображения (погрудное, поясное или
      ростовое) и имя святого. Уместно детализировать эпитет
      святого и особенности его иконографии, если они хорошо
      идентифицируются. Указывать наличие колончатой надписи.
      Для описания легенды и ободка действуют те же правила,
      что и для лицевой стороны.
    </p>

  </div>

  <div className="notes">
    <div className="notes-title">Примечания</div>
    <ol>
      <li>
        В базе данных и в данной работе, следуя традиции, принятой в своде
        В. Л. Янина, за лицевую сторону печати принимается сторона
        с греческим текстом.
      </li>

      <li>
        В качестве примера взято описание одной из печатей
        Всеволода Ярославича (†1093).
      </li>

      <li>
        В скобках приведены необязательные, но возможные элементы описания.
      </li>
    </ol>
  </div>

</div>

</div>


          </div>

          

        </div>

      </div>
    </>
  );
};

export default Editorial;